// dev console warning
let isShowConsoleWarning = false;

// PWA does not work
export function onDevToolsChange(ev) {
    console.log('devtoolschange', ev);
    if (!isShowConsoleWarning && ev.detail.isOpen) {
        const titleStyle =
            'font-family:Arial; color:red; font-style:bold; text-shadow:-1px -1px 0 #000, 1px -1px 0 #000,-1px 1px 0 #000,1px 1px 0 #000; font-size:3rem;';
        console.log('%cStop!', titleStyle);
        const bodyStyle = 'font-family:Arial; color:black; font-style:bold; font-size:1rem;';
        console.log(
            '%cThis is a browser feature intended for developers. If someone told you to copy-paste something here to enable a feature or "hack" someone\'s account, it is a scam and will give them access to your account.',
            bodyStyle,
        );
        isShowConsoleWarning = true;
    }
}

// Prevent right-click context menu
export function onContextMenu(ev) {
    ev.preventDefault();
    return false;
}
